import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {
  constructor() {}

  public validateForm(form: NgForm): Observable<Boolean> {
    return Observable.create(observer => {
      if (form.valid) {
        observer.next(true);
      } else {
        Object.keys(form.form.controls).map(key => {
          form.form.get(key).markAsDirty();
          form.form.get(key).updateValueAndValidity();
        });
        observer.next(false);
      }
      observer.complete();
    });
  }
}
